import { createBEM } from "~/plugins/bem"

export default function useBEM (blockName: string) {
  return createBEM(blockName)
}